// extracted by mini-css-extract-plugin
export var cartContainer = "_ke-4";
export var gray = "_ke-1";
export var itemContainer = "_ke-2";
export var itemDetails = "_ke-3";
export var strong = "_ke-0";